export const navigation = [
  ["/", "홈"],
  ["/institution-performance", "기관·행사 공연 섭외"],
  ["/group-visit", "어린이집·유치원 단체관람"],
  ["/about", "마이리틀클래식 소개"],
  ["/inquiry", "문의"],
];

export const commonFaqs = [
  ["몇 세부터 관람할 수 있나요?", "아이들의 연령과 발달 단계에 맞춰 프로그램을 제안합니다. 구체적인 권장 연령은 상담 후 안내드립니다."],
  ["공연 시간은 얼마나 되나요?", "연령, 프로그램과 행사 구성에 따라 달라집니다. 집중 시간과 현장 일정을 함께 고려해 안내드립니다."],
  ["몇 명까지 참여할 수 있나요?", "공간, 관객 연령, 인솔자 구성과 공연 방식에 따라 상담 후 확정합니다."],
  ["프로그램을 선택할 수 있나요?", "가능합니다. 행사 목적과 아이들의 연령을 확인한 뒤 적합한 Story & Music 프로그램을 함께 정합니다."],
  ["기관 제출 서류가 필요한 경우는요?", "필요한 서류의 종류를 문의 시 알려주세요. 발급 가능 여부와 절차를 확인해 안내드립니다."],
];

export const strengths = [
  ["01", "전문 연주자의 라이브", "녹음이 아닌 실제 악기의 울림과 연주자의 호흡을 가까이에서 만납니다."],
  ["02", "영유아 맞춤 설계", "집중 시간과 발달 단계를 고려해 이야기, 질문, 움직임과 음악을 연결합니다."],
  ["03", "이야기와 클래식", "친숙한 서사를 따라가며 클래식 음악을 자연스럽게 경험합니다."],
  ["04", "참여하는 공연", "아이의 반응을 통제하지 않고 공연을 함께 만드는 중요한 일부로 받아들입니다."],
  ["05", "현장에서 쌓은 경험", "전용 공연장과 기관 초청 공연을 운영하며 다양한 공간과 관객을 만나왔습니다."],
];

export const performanceFlow = [
  ["01", "한 권의 동화책을 공연으로 만납니다", "신데렐라, 미운 아기 오리처럼 아이들에게 친숙한 실제 동화책 한 권을 한 편의 공연으로 구성합니다."],
  ["02", "삽화와 함께 구연동화를 따라갑니다", "동화책의 이야기를 들려주는 동안 책 속 삽화가 공연장 벽면과 스크린에 펼쳐져, 아이들이 장면을 눈으로 보며 이야기를 따라갑니다."],
  ["03", "이야기 속 장면마다 클래식이 연주됩니다", "동화의 플롯과 인물의 감정에 어울리는 클래식 곡이 이야기 중간중간 전문 연주자의 라이브 연주로 이어집니다."],
  ["04", "음악과 함께 미디어아트가 공간을 채웁니다", "클래식 곡이 연주될 때는 곡의 분위기와 감정을 표현한 미디어아트가 펼쳐져, 이야기의 장면을 더욱 생생하게 경험하게 합니다."],
];

export const institutionTargets = ["육아종합지원센터 영유아 프로그램", "공공기관 가족 초청 공연", "도서관·문화센터 어린이 문화공연", "어린이집·유치원 원내 문화행사", "어린이날·연말·새 학기 행사", "기업 임직원·지역 가족행사"];
export const institutionFeatures = ["공연팀이 기관 공간으로 직접 방문", "관객 연령과 인원에 맞춘 참여형 진행", "행사 목적에 맞춘 오프닝·엔딩", "공간과 예산에 따른 연주 편성 조정", "실내·야외 진행 방식 협의", "환경에 따라 프로젝션 맵핑 협의"];
export const institutionFaqs = [
  ["피아노가 없어도 가능한가요?", "보유 악기와 공간 조건을 확인해 가능한 편성을 제안드립니다."],
  ["교실이나 강당에서도 가능한가요?", "가능 여부는 공간 크기, 관객 배치, 전기와 음향 조건을 확인한 후 안내드립니다."],
  ["연주자 수를 조정할 수 있나요?", "공간과 예산, 프로그램에 맞춰 편성을 상담합니다."],
  ["지방 또는 야외 공연도 가능한가요?", "지역, 이동 조건과 야외 우천 대안 등을 함께 검토해 안내드립니다."],
  ["견적에는 어떤 항목이 포함되나요?", "일정, 지역, 편성, 장비와 준비 범위를 확인한 뒤 항목별로 안내드립니다."],
];
export const institutionCases = [
  { date: "2025.03", region: "전남 진도", institution: "진도군가족센터", title: "우리 가족 클래식 소풍", venue: "진도향토문화회관", audience: "영유아 가족 · 300명", image: "/images/cases/jindo.webp" },
  { date: "2025.05", region: "전북 고창", institution: "고창문화의전당", title: "아이와 함께하는 첫 클래식", venue: "고창문화의전당", audience: "영유아 가족 · 300명", image: "/images/cases/gochang.webp" },
  { date: "2025.07", region: "충남 태안", institution: "태안군 아이키움터", title: "여기행복 문화공연", venue: "태안문화원", audience: "어린이집·유치원 단체 · 200명 · 2회", image: "/images/public-hall.webp" },
  { date: "2025.09", region: "경북 김천", institution: "김천시 육아종합지원센터", title: "토요어린이문화공연 – 동화 속 클래식", venue: "김천시 육아종합지원센터", audience: "영유아 가족 · 300명", image: "/images/cases/gimcheon.webp" },
  { date: "2025.11", region: "전북 남원", institution: "남원시 육아종합지원센터", title: "가족음악회 – 겨울을 기다리는 클래식 놀이터", venue: "남원시 육아종합지원센터", audience: "영유아 가족 · 30가정", image: "/images/cases/namwon.webp" },
  { date: "2026.04", region: "경남 진주", institution: "진주시 육아종합지원센터", title: "어린이 문화공연 – 봄날의 음악동화", venue: "진주시 육아종합지원센터", audience: "영유아 가족 · 160명 · 2회", image: "/images/cases/jinju.webp" },
  { date: "2026.07", region: "경기 파주", institution: "파주시 육아종합지원센터", title: "한여름음악회", venue: "솔가람아트홀", audience: "영유아 가족 · 300명", image: "/images/hero-institution.webp" },
];

export const venueFeatures = ["어린이집·유치원 단체 예약제 운영", "전문 연주자의 라이브 클래식", "이야기와 미디어아트가 결합된 공연", "아이들의 반응을 받아들이는 참여형 진행", "공연 후 연주자와 함께하는 악기 체험"];
export const groupVisitFaqs = [
  ["몇 세부터 방문할 수 있나요?", "어린이집·유치원에 다니는 아이들이라면 모두 관람할 수 있습니다. 연령 구성에 맞춰 진행 방식과 프로그램을 조정합니다."],
  ["한 반만 방문해도 가능한가요?", "아이와 인솔자 구성, 희망일과 공연 방식에 따라 가능 여부를 안내드립니다."],
  ["최대 인원은 몇 명인가요?", "80명까지 관람한 회차가 있습니다. 좌석이 정해져 있지 않은 좌식 공연장이라 인원과 연령 구성에 따라 유연하게 배치하며, 방문 인원을 알려주시면 가능 여부를 안내드립니다."],
  ["당일 결석이 생기면 관람료는 어떻게 되나요?", "결석한 원생은 제외하고 공연 당일 실제 방문 인원을 기준으로 정산합니다. 다만 원생 30명까지는 기본 관람료 45만 원이 적용됩니다."],
  ["공연 후 악기 체험이 가능한가요?", "공연 후 악기 체험이 포함될 수 있으며, 프로그램과 운영 조건에 따라 세부 구성을 안내드립니다."],
];

export const inquiryTypes = {
  institution: "우리 기관·행사에 공연팀을 섭외하고 싶어요",
  visit: "어린이집·유치원 단체관람을 문의하고 싶어요",
  unsure: "아직 결정하지 못했어요",
};

export const venueFaqs = [
  ["공연장은 어디에 있나요?", "경기도 화성시 동탄대로 537 라스플로레스 B동 425호입니다. 네이버 지도에서 '마이리틀클래식'으로 검색하시면 길찾기가 가능합니다."],
  ["전체 일정은 얼마나 걸리나요?", "공연 45분과 악기 체험 15분 내외로, 입장과 착석 시간을 제외한 프로그램은 총 1시간입니다. 연령과 프로그램 구성에 따라 조정됩니다."],
  ["관람료는 어떻게 되나요?", "원생 30명 이상은 1인 15,000원(부가세 별도)이며, 30명 미만은 기본 관람료 450,000원이 적용됩니다. 인솔 교사는 무료이고, 공연 당일 실제 방문한 원생 수를 기준으로 정산합니다."],
  ["버스는 어디에 세우나요?", "차량은 건물 앞에서 바로 하차합니다. 하차 지점부터 공연장까지 저희가 직접 길안내를 해 드리니 아이들을 인솔해 따라오시면 됩니다."],
  ["몇 명까지 관람할 수 있나요?", "80명까지 관람한 회차가 있습니다. 좌석이 정해져 있지 않은 좌식 공연장이라 인원과 연령 구성에 따라 유연하게 배치합니다. 방문 인원을 알려주시면 가능 여부를 안내드립니다."],
  ["몇 세부터 관람할 수 있나요?", "어린이집·유치원에 다니는 아이들이라면 모두 관람할 수 있습니다. 연령 구성에 맞춰 진행 방식과 프로그램을 조정합니다."],
  ["아이가 울거나 돌아다니면 어떻게 하나요?", "괜찮습니다. 마이리틀클래식은 아이의 움직임과 목소리를 공연을 방해하는 요소가 아니라 공연의 일부로 받아들입니다. 진행자가 아이들의 반응을 무대로 연결하며 공연을 이끕니다."],
  ["다른 기관과 함께 관람하나요?", "한 기관이 단독으로 방문하기도 하고, 두 기관이 일정을 맞춰 함께 관람하기도 합니다. 예약 상황과 전체 인원을 확인한 뒤 안내드립니다."],
  ["별도로 준비할 것이 있나요?", "따로 준비하실 것은 없습니다. 바닥에 앉아 관람하므로 아이들이 편하게 움직일 수 있는 복장으로 오시면 됩니다."],
  ["한 반만 방문해도 되나요?", "아이와 인솔자 구성, 희망일과 공연 방식에 따라 가능 여부를 안내드립니다."],
];
